import React from 'react';
import styles from './styles.module.scss';

export const UnitDescription = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.descriptionContainer}>{children}</div>;
};

